import React from "react";

const StarterMainContent = () => {
  return (
    <div className=" page-main">
      <div className=" main-content container-fluid w-100"> Starter</div>
    </div>
  );
};

export default StarterMainContent;
